module.exports = __webpack_public_path__ + "img/icon3.742e784d.png";